import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

// #1090: sayfa kodu inerken görünen yedek. Hızlı yüklemede hiç görünmez (200 ms gecikme), sonra yumuşakça belirir;
// "hareketi azalt" açıksa belirme ve nabız animasyonları kapanır. Görsel iskelet, ekran okuyucuya metin olarak okunur.
export function RouteFallback({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'mx-auto w-full max-w-5xl space-y-6 p-6',
        'animate-in fade-in duration-300 delay-200 fill-mode-backwards motion-reduce:animate-none',
        className,
      )}
    >
      <span className="sr-only">Yükleniyor…</span>
      <div aria-hidden="true" className="space-y-6">
        <div className="space-y-2">
          <Skeleton className="h-7 w-48 motion-reduce:animate-none" />
          <Skeleton className="h-4 w-96 max-w-full motion-reduce:animate-none" />
        </div>
        <div className="grid gap-4 sm:grid-cols-3">
          <Skeleton className="h-24 motion-reduce:animate-none" />
          <Skeleton className="h-24 motion-reduce:animate-none" />
          <Skeleton className="h-24 motion-reduce:animate-none" />
        </div>
        <Skeleton className="h-64 motion-reduce:animate-none" />
      </div>
    </div>
  )
}
